import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import FieldLabelWrapper from '../../../../../../../../../../features/components/Form/FieldLabelWrapper'
import Field from '../../../../../../../../../../components/Form/Field'

import { wellbeingFieldValueValidator } from './helpers'

import {
  AVERAGE_DECREASED_ANXIETY_RATING_AFTER,
  AVERAGE_DECREASED_ANXIETY_RATING_BEFORE,
  AVERAGE_HAPPINESS_RATING_AFTER,
  AVERAGE_HAPPINESS_RATING_BEFORE,
  AVERAGE_LIFE_SATISFACTION_RATING_AFTER,
  AVERAGE_LIFE_SATISFACTION_RATING_BEFORE,
  AVERAGE_PURPOSE_OF_LIFE_RATING_AFTER,
  AVERAGE_PURPOSE_OF_LIFE_RATING_BEFORE,
  STAKEHOLDERS_LIST
} from '../../../../../../stakeholdersFields'

import useSectionStyles from '../styles'
import useStyles from './styles'
import classnames from 'classnames'

const wellbeingFields = [
  {
    label: 'Life Satisfaction Rating',
    beforeField: AVERAGE_LIFE_SATISFACTION_RATING_BEFORE,
    afterField: AVERAGE_LIFE_SATISFACTION_RATING_AFTER
  },
  {
    label: 'Purpose of Life Rating',
    beforeField: AVERAGE_PURPOSE_OF_LIFE_RATING_BEFORE,
    afterField: AVERAGE_PURPOSE_OF_LIFE_RATING_AFTER
  },
  {
    label: 'Happiness Rating',
    beforeField: AVERAGE_HAPPINESS_RATING_BEFORE,
    afterField: AVERAGE_HAPPINESS_RATING_AFTER
  },
  {
    label: 'Decreased Anxiety Rating',
    beforeField: AVERAGE_DECREASED_ANXIETY_RATING_BEFORE,
    afterField: AVERAGE_DECREASED_ANXIETY_RATING_AFTER
  }
]

const WellbeingFields = ({ formik, index }) => {
  const { t } = useTranslation()

  const sectionClasses = useSectionStyles()
  const classes = useStyles()

  return (
    <>
      {wellbeingFields.map((field, fieldIndex) => (
        <div key={fieldIndex} className={sectionClasses.rowWith2Items}>
          <div className={sectionClasses.col}>
            <FieldLabelWrapper
              label={t(`${field.label} Before`)}
              labelFor={`${STAKEHOLDERS_LIST}[${index}][${field.beforeField}]`}
              className={sectionClasses.wellbeingFieldWrapper}
              contentClassName={sectionClasses.wellbeingFieldWrapperContent}
            >
              <Field
                className={classnames(sectionClasses.fieldInRow, classes.wellbeingField)}
                formik={formik}
                name={`${STAKEHOLDERS_LIST}[${index}][${field.beforeField}]`}
                type={'number'}
                isAllowed={wellbeingFieldValueValidator}
              />
            </FieldLabelWrapper>
          </div>
          <div className={sectionClasses.col}>
            <FieldLabelWrapper
              label={t(`${field.label} After`)}
              labelFor={`${STAKEHOLDERS_LIST}[${index}][${field.afterField}]`}
              className={sectionClasses.wellbeingFieldWrapper}
              contentClassName={sectionClasses.wellbeingFieldWrapperContent}
            >
              <Field
                className={classnames(sectionClasses.fieldInRow, classes.wellbeingField)}
                formik={formik}
                name={`${STAKEHOLDERS_LIST}[${index}][${field.afterField}]`}
                type={'number'}
                isAllowed={wellbeingFieldValueValidator}
              />
            </FieldLabelWrapper>
          </div>
        </div>
      ))}
    </>
  )
}

WellbeingFields.propTypes = {
  formik: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired
}

export default WellbeingFields
